import { render } from "./TableTithe.vue?vue&type=template&id=13f0d978&scoped=true"
import script from "./TableTithe.vue?vue&type=script&lang=js"
export * from "./TableTithe.vue?vue&type=script&lang=js"

import "./TableTithe.vue?vue&type=style&index=0&id=13f0d978&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13f0d978"]])

export default __exports__